import MovieNight from './pages/MovieNight';
import './App.css';
import './accountOverrides.css';
import NavBar from './navbar';
import MovieComponent from './content';
import { Routes, Route, Link, useLocation } from "react-router-dom";
import MovieDetails from './Moviesdetails';
import { useEffect, useState } from 'react';
import Air from './Airing';
import Upcoming from './upcoming';
import SeriesComponent from './tv';
import SeriesDetails from './Seriesdetails';
import Dev from "./pages/Dev";
import PersonalSpace from "./pages/PersonalSpace";
import ExperienceHub from "./pages/ExperienceHub";
import Hunch from "./pages/Hunch";
import MovieShorts from './pages/MovieShorts';
import PersonDetails from './PeopleFeatures';
import BottomTabs from './BottomTabs';
import SecondScreen from './SecondScreen';
import './mobilePlayerFixes.css';
/**
 use this one for subnav and now removed since the problem is fixed with another solution and also still 
 commenting this to keep some concepts in mind but never mind.
 import { useParams } from 'react-router-dom';
 import Review from './contentnav';
 const ReviewCall = () => {
  const { id } = useParams();
  return <Review id={id} />;
  <Route path='/rev/:id' element={<ReviewCall />} />
};**/

function App() {
  const location = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
  const [search, setSearch] = useState("");
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('hedone-theme');
    if (savedTheme === 'light' || savedTheme === 'dark') return savedTheme;
    return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('hedone-theme', theme);
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'light' ? '#f8f7f4' : '#0c0e13');
  }, [theme]);

  useEffect(() => {
    let backListener;
    const registerAndroidBack = async () => {
      if (!window.Capacitor?.isNativePlatform?.()) return;
      const { App: NativeApp } = await import('@capacitor/app');
      backListener = await NativeApp.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack || window.history.length > 1) window.history.back();
        else NativeApp.minimizeApp();
      });
    };
    registerAndroidBack();
    return () => backListener?.remove();
  }, []);

  return (
    <div className={`app-container ${['/','/series'].includes(location.pathname) && !search ? 'is-discovery-route' : ''}`}>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <NavBar
        setSearch={setSearch}
        search={search}
        theme={theme}
        toggleTheme={() => setTheme(current => current === 'dark' ? 'light' : 'dark')}
      />
      <main id="main-content" tabIndex={-1}>
      <Routes>
        <Route path="/" element={<MovieComponent search={search} />} />
        <Route path="/movie/:id" element={<MovieDetails />} />
        <Route path='/tv/:id' element={<SeriesDetails />}/>
        <Route path='/air' element={<Air search={search} />} />
        <Route path='/upcoming' element={<Upcoming search={search} />} />
        <Route path='/series' element={<SeriesComponent search={search} />} />
        <Route path="/dev" element={<Dev />} />
        <Route path="/me" element={<PersonalSpace />} />
        <Route path="/orbit" element={<ExperienceHub />} />
        <Route path="/hunch" element={<Hunch />} />
        <Route path="/movie-night" element={<MovieNight />} />
        <Route path="/shorts" element={<MovieShorts />} />
        <Route path="/companion" element={<SecondScreen />} />
        <Route path="/person/:id" element={<PersonDetails />} />
      </Routes>
      </main>
      <BottomTabs />
      <footer className="site-footer"><div><strong>HEDONE</strong><span>For the love of a good story.</span></div><nav aria-label="Footer navigation"><Link to="/">Discover</Link><Link to="/series">Series</Link><Link to="/movie-night">Movie night</Link><Link to="/dev">About Hedone</Link></nav></footer>
    </div>
  );
}

export default App;
